import * as React from 'react'
import { castingStoreCanRenderCastingTypeInput, StoreProps } from '../../../services/stores/casting.store'
import { pxToEm } from '../../../services/utils/dom.service'
import { scrollTo, getPosition } from '../../../../utils/dom'
import CastingStep1Component from './casting-step-1.component'
import CastingStep2Component from './casting-step-2.component'
import CastingStep3Component from './casting-step-3.component'
import FlashIncompleteStoreComponent from '../../shared/flashes/flash-incomplete-store.component'

interface State {
  step2Unlocked: boolean
  step3Unlocked: boolean
}

export default class CastingStepsDesktopComponent extends React.Component<StoreProps, State> {
  private refStep1 = React.createRef<HTMLDivElement>()
  private refStep2 = React.createRef<HTMLDivElement>()
  private refStep3 = React.createRef<HTMLDivElement>()

  state: State = { step2Unlocked: false, step3Unlocked: false }

  private nextStep (stepNum: 1 | 2) {
    const { store, data } = this.props
    const newState: Partial<State> = {}
    const nextStep = stepNum + 1

    if (!this.state[`step${nextStep}Unlocked` as 'step2Unlocked']) {
      newState[`step${nextStep}Unlocked` as 'step2Unlocked'] = store.validatesLegacyCastingStep(stepNum)
    }

    this.setState(newState as State, () => {
      store.setDesktopContainerHeight()
      if (nextStep === 2 && !castingStoreCanRenderCastingTypeInput(data)) store.nextFocus({ from: 'end-of-step-1' })
      if (nextStep === 3) store.nextFocus({ from: 'end-of-step-2' })
      setTimeout(() => this.scrollToStep(stepNum + 1 as 1 | 2 | 3))
    })
  }

  private scrollToStep (stepNum: 1 | 2 | 3) {
    const headerHeight = (document.getElementsByClassName('castingHeader-container')[0] as HTMLDivElement).offsetHeight
    scrollTo(getPosition(this[`refStep${stepNum}`].current).top - headerHeight - 10)
  }

  render () {
    const { store, data: { market, desktopContainerHeight } } = this.props
    store.scrollToLegacyStep = this.scrollToStep.bind(this)

    const castingSteps = [
      <div key="1" ref={ this.refStep1 }>
        <CastingStep1Component btnOnClick={ () => this.nextStep(1) } store={ store } data={ store.data } />
      </div>,
      <div key="2" ref={ this.refStep2 }>
        { store.data.offeredService && <CastingStep2Component btnOnClick={ () => this.nextStep(2) } store={ store } data={ store.data } /> }
      </div>,
      <div key="3" ref={ this.refStep3 }>
        { store.data.offeredService && <CastingStep3Component store={ store } data={ store.data } /> }
      </div>
    ]

    const currentSteps = castingSteps.filter((_, index) => index === 0 || this.state[`step${index + 1}Unlocked` as 'step2Unlocked'])

    return <div className="castingContainer" style={{ minHeight: `${pxToEm(desktopContainerHeight)}em` }}>
      { currentSteps }

      { !market['store_completed?'] && <FlashIncompleteStoreComponent store_incomplete_reasons={ market.store_incomplete_reasons } /> }
    </div>
  }
}
